import(/* webpackMode: "eager" */ "/workspace/app/global-error.jsx")